module.exports = __webpack_public_path__ + "assets/853d48a6f186f844106b4081a36c4d57.png";